import * as React from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableFooter from "@mui/material/TableFooter";
import { styled } from "@mui/material/styles";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#484d50",
      color: "#fffcfc",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 12,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  
  return (
    <React.Fragment>
      {/* Movimientos */}
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <StyledTableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </StyledTableCell>
        
        <StyledTableCell component="th" scope="row">
          {row.Etiquetas_de_fila}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {row.Toneladas}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {row.AuEq_Gr_t}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {row.Au_Gr_t}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {row.Ag_gr_t}
        </StyledTableCell>

        <StyledTableCell align="right">
          {row.Cu_pct}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {row.Fe_pct}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {row.S_pct}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {row.As_pct}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {row.Bi_ppm}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {row.Cd_ppm}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {row.Zn_pct}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {row.AuEq_Oz}
        </StyledTableCell>
      
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={15}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }} >
              <Table size="small">
                <TableBody>
                 {row.dataFechas.map((subItem, index) => (
                    <SecondRow subRow={subItem} />
                 ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function SecondRow(props) {
  const { subRow } = props;
  
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#484d50",
      color: "#fffcfc",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 12,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <StyledTableCell>
          
        </StyledTableCell>

        <StyledTableCell component="th" scope="row">
          {subRow.Fecha}
        </StyledTableCell>

        <StyledTableCell align="right">
          {subRow.Toneladas}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {subRow.AuEq_Gr_t}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {subRow.Au_Gr_t}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {subRow.Ag_gr_t}
        </StyledTableCell>

        <StyledTableCell align="right">
          {subRow.Cu_pct}
        </StyledTableCell>

        <StyledTableCell align="right">
          {subRow.Fe_pct}
        </StyledTableCell>

        <StyledTableCell align="right">
          {subRow.S_pct}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {subRow.As_pct}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {subRow.Bi_ppm}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {subRow.Cd_ppm}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {subRow.Zn_pct}
        </StyledTableCell>
        
        <StyledTableCell align="right">
          {subRow.AuEq_Oz}
        </StyledTableCell>
      </TableRow>

    </React.Fragment>
  );
}

export default function FifthCollapsibleTable({ rows, resumenPonderados }) {
  // Estilo para el footer sticky:
  const StickyFooterCell = styled(TableCell)({
    position: 'sticky',
    bottom: 0,
    zIndex: 2,
    background: '#fff', // Asegura contraste con el contenido
  });

  return (
    <TableContainer component={Paper} sx={{ maxHeight: "60vh", width: "100%" }}>
      <Table aria-label="collapsible table" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Etiquetas de fila
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Toneladas
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              AuEq Gr/t
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Au Gr/t
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Ag gr/t
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Cu%
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Fe %
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              S %
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              As %
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Bi_ppm
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Cd_ppm
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Zn %
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              AuEq Oz
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <Row key={index} row={row} />
          ))}
        </TableBody>

        <TableFooter>
          <TableRow>
            <StickyFooterCell  sx={{background: "#f5f5f5"}}/>
            <StickyFooterCell  sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              Total General
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>  
              {resumenPonderados.Toneladas}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f",  background: "#f5f5f5" }}>
              {resumenPonderados.AuEq_Gr_t}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.Au_Gr_t}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.Ag_gr_t}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.Cu_pct}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.Fe_pct}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.S_pct}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.As_pct}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.Bi_ppm}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.Cd_ppm}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.Zn_pct}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.AuEq_Oz}
            </StickyFooterCell >
          </TableRow>
        </TableFooter>

      </Table>
    </TableContainer>
  );
}
